<template>
    <div class="tab">
        <div class="center">
            <div class="head-i">
                <img src="../../static/home/logo.png" alt="">
                <!-- <img src="../../static/home/qcwllogo.png" alt=""> -->
                <!-- <img src="../../static/home/logo1.png" alt=""> -->
            </div>
            <div class="head-list">
                <router-link to="/">
                    <div @click="changeTab('1')" :style="tabIndex == 1?'border-bottom:2px solid #3476C1;color:#3476C1;font-weight:600;':''">首页</div>
                </router-link>
                <router-link to="/policy">
                    <div @click="changeTab('2')" :style="tabIndex == 2?'border-bottom:2px solid #3476C1;color:#3476C1;font-weight:600;':''">政策</div>
                </router-link>
                <div @click="changeTab('8')" style="cursor: pointer;" :style="tabIndex == 8?'border-bottom:2px solid #3476C1;color:#3476C1;font-weight:600;':''">职业技能提升</div>
                <router-link to="/learn">
                    <div @click="changeTab('3')" :style="tabIndex == 3?'border-bottom:2px solid #3476C1;color:#3476C1;font-weight:600;':''">学习中心</div>
                </router-link>

                <router-link to="/serve">
                    <div @click="changeTab('4')" :style="tabIndex == 4?'border-bottom:2px solid #3476C1;color:#3476C1;font-weight:600;':''">服务</div>
                </router-link>
                <router-link to="/activity">
                    <div  @click="changeTab('5')" :style="tabIndex == 5?'border-bottom:2px solid #3476C1;color:#3476C1;font-weight:600;':''">活动</div>
                </router-link>
                <router-link to="/expert">
                   <div  @click="changeTab('6')" :style="tabIndex == 6?'border-bottom:2px solid #3476C1;color:#3476C1;font-weight:600;':''">专家库</div>
                </router-link> 
                <router-link to="/project" style="margin-right:20px">
                   <div @click="changeTab('7')" :style="tabIndex == 7?'border-bottom:2px solid #3476C1;color:#3476C1;font-weight:600;':''">项目库</div>
                </router-link>  
                <!-- <router-link to="/pay">
                   <div style="margin-right:0px;" @click="changeTab('8')" :style="tabIndex == 8?'border-bottom:2px solid #3476C1;color:#3476C1;font-weight:600;':''">付费资讯</div>
                </router-link>                               -->
            </div>
            
            <!-- <div class="login" v-if="!tokenCheck">
                <router-link to="/login">
                    <div class="login-btn">登录</div>
                </router-link>
                <router-link  to="/register">
                    <div class="login-btn" style="background:#0ca8e1;margin-right:18px;">注册</div>
                </router-link>
                
            </div>
            <div class="tome" v-if="tokenCheck">
                <div class="tome-wrap">
                    {{mobile}}
                    <img :src="headImg" alt="" @click="toMe()">
                    <div class="out" @click="out">退出账户</div>
                </div>
            </div> -->
            
            
        </div>
    </div>


</template>

<script>
    export default {
        name: "navigation",
         data () {
            return {
                tabIndex:1,
                catalogueList:[],
                tokenCheck:false,
                headImg:'',
                mobile:'',
            };
        },
        props: ["tabindex"],
        methods:{
            decide(){
                if(localStorage.usMobile){
                    this.$router.push({name:'people'})
                }
                else{
                    alert("您还没有登陆，请先登录！");
                    this.$router.push({name:'passwordLogin'})
                }
            },
			toVideoClass(s){
                this.$emit('event1',s)
                sessionStorage.setItem('tabIndex',3);
                this.$router.push({
                    path: '/videoclass',
                    query: {
                        catalogueId: s
                    }
                })
            },
            toMe(){
                sessionStorage.setItem('tabIndex',0);
                this.$router.push({
                    path: '/me',
                    query: {}
                })
            },
            changeTab(s){
               if(s == 8) {
                   window.open('https://muke.jycyfww.com/')
               } else {
                   this.tabIndex = s;
                    let str = s;
                    sessionStorage.setItem('tabIndex',s);
               }
            },
            out(){
                localStorage.removeItem('token')  //删除key以及key中的内容
            //    localStorage.clear();
                this.tokenCheck = false;

                this.$router.push({
                    path: '/login',
                    query: {}
                })
            },
            
        },
        created(){
            let sStorage = sessionStorage.getItem('tabIndex');
            if(sStorage){
                this.tabIndex = sStorage;
            }
            if(localStorage.token){
                this.tokenCheck = true;
                this.headImg = localStorage.headImg;
                this.mobile = localStorage.mobile;
            }else{
                this.tokenCheck = false;
            }
            
        },
        mounted() {
            if (this.tabindex == 0) {
                this.tabIndex = 0
            }
        }
    }
</script>

<style scoped lang="less">  
    .tab{
        width:100%;height:80px;background:rgba(255,255,255,1);
        box-shadow:0px 2px 20px 0px rgba(153,153,153,0.2);
        position: absolute;top:40px;z-index:22;
        .center{
            width:1200px;height:80px;line-height: 80px;margin:0 auto;
            .head-i{
                float:left;padding-top:15px;
                // img{display:block;width:285px;height:56px;}
                img{display:block;width:260px;height:51px;}
                
            }
            .head-list{
                float:right;padding-top:16px;
                div{
                    float:left;height:46px;line-height: 46px;
                    font-size:16px;
                    font-family:MicrosoftYaHei;
                    font-weight:400;
                    color:#333333;
                    margin-left:50px;
                }   
            }
            .login{
                float: right;padding-top:58px;
                .login-btn{
                    float:left;width:59px;height:33px;line-height:33px;font-size:16px;text-align:center;
                    background:#f2981e;color:#fff;margin-left:8px;
                }
            }
            .tome{
                float: right;height:155px;line-height: 155px;padding-top:60px;
                .tome-wrap{
                    display:block;float:left;width:143px;height:29px;line-height: 29px;
                    font-size:12px;color:#0066ae;position: relative;padding-left:31px;background:#eee;
                    border-radius:15px;position: relative;
                    img{
                        display:block;float:left;width:46px;height:46px;border-radius: 50%;
                        border:1px solid #b6b6;position:absolute;top:-8px;left:-23px;
                    }
                    .out{
                        width:100%;height:30px;line-height: 30px;color:black;cursor: pointer;
                        background:#eee;display:none;text-align: center;
                        position:absolute;width:123px;left:20px;
                    }
                }
                .tome-wrap:hover{border-radius: 0px 15px 0px 15px;}
                .tome-wrap:hover .out{display: block;border-radius: 0px 0px 15px 15px;}
            }
           
        }
    }


</style>